// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".military-report__report-block{min-height:200px}.military-report__pos-relative{position:relative}", ""]);
// Exports
module.exports = exports;
